import React from 'react';
import { useTranslation } from 'react-i18next';

import { CoreLink } from '..';
import { NEWSLETTER_URL_ORGS } from '../../config/constants';

const KPNewsletterForm = () => {
  const { t } = useTranslation();

  return (
    <div className="FooterMenu__newsletter">
      {/* TODO: implement as webform */}
      <h4>{t('kp.newsletter.title')}</h4>
      <p>{t('kp.newsletter.body')}</p>
      <CoreLink className="Button Button--primary Button--icon icon-after icon-arrow-right icon-before moving-arrow icon-variant-4" to={NEWSLETTER_URL_ORGS}>{t('kp.newsletter.button-text')}</CoreLink>
    </div>
  );
};

export default KPNewsletterForm;
